import { Stack } from '@mui/material'
import { clone, pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseSentimentCheckData } from './ConfigData'

type SentimentCheck = {
  sentimentCheck: string
  SentimentPrompt: {
    en: string[]
  }
}
type SentimentCheckEnhanced = CustomComponentEnhanced<SentimentCheck>

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch =
    useUpdateCustomComponent<SentimentCheck>(componentID)
  const currentSemanticSearch =
    useGetCustomComponent<SentimentCheck>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseSentimentCheckData
  )
  const parseData = (data?: SentimentCheckEnhanced | null) => {
    if (!data) return {}
    const sentimentData = clone(data)
    if (
      sentimentData.settings?.SentimentPrompt?.en?.length &&
      sentimentData.settings.SentimentPrompt.en.length >= 1
    ) {
      sentimentData.settings.SentimentPrompt = {
        en: sentimentData.settings.SentimentPrompt.en[0].split('\n'),
      }
    }
    return pick(['name', 'description', 'settings', 'type'], sentimentData)
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    await updateSemanticSearch.mutateAsync({
      ...parseData(data as unknown as CustomComponentEnhanced<SentimentCheck>),
    } as SentimentCheckEnhanced)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
